// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"9636d785","293":"608c21b2","360":"58bed5c3","453":"9717c9c3","879":"5b62ea7f","885":"1f9dfbbc","947":"99940e51"}[chunkId] + ".chunk.js";
};